/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_Ask_ImportInputs */

const en_ui_onboarding_ask_import = /** @type {(inputs: Ui_Onboarding_Ask_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 · The import`)
};

const de_ui_onboarding_ask_import = /** @type {(inputs: Ui_Onboarding_Ask_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 · Der Import`)
};

/**
* | output |
* | --- |
* | "3 · The import" |
*
* @param {Ui_Onboarding_Ask_ImportInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_ask_import = /** @type {((inputs?: Ui_Onboarding_Ask_ImportInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_Ask_ImportInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_ask_import(inputs)
	return de_ui_onboarding_ask_import(inputs)
});